import * as React from "react";
export function isRenderable(arg) {
    return (React.isValidElement(arg) ||
        typeof arg === "number" ||
        typeof arg === "string" ||
        typeof arg === "boolean" ||
        arg === null ||
        arg === undefined ||
        arg instanceof Array);
}
//# sourceMappingURL=isRenderable.js.map